export default __webpack_public_path__ + "static/media/footer_bg_m.07c78b3a.jpg";